import { render } from "./formal_document_entity_type_selector_view.html?vue&type=template&id=49166bc0&scoped=true&external"
import script from "./formal_document_entity_type_selector.js?vue&type=script&lang=js&external"
export * from "./formal_document_entity_type_selector.js?vue&type=script&lang=js&external"

import "./FormalDocumentEntityTypeSelector.vue?vue&type=style&index=0&id=49166bc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49166bc0"]])

export default __exports__